import { sortWeekdays } from "../utils/date";
import { FULL_DAYS } from "./strings";

export const NO_LOOKUP_TABLES =
  "Unable to fetch look up tables for specified depot";
export const ERROR_REMOVE_LAST_POSTCODE = (sector) =>
  `Unable to remove last postcode within ${sector} sector`;
export const ERROR_REMOVE_IN_USE_POSTCODE = (postcode) =>
  `Unable to remove ${postcode} because it is in use`;
export const INVALID_DEPOT_OR_DATE = "Invalid depot or date";

export const ERROR_FETCH_DEPOT_CONFIG = "Unable to load depot config.";
export const SELECTED_ROUTE_NO_POSTCODES =
  "Selected route does not have any postcodes allocated";
export const SUCCESS_FETCH_POSTCODE_ALLOCATIONS =
  "Depot postcodes sectors loaded successfully.";
export const ERROR_FETCH_POSTCODE_ALLOCATIONS =
  "Unable to load depot postcodes sectors.";
export const SUCCESS_FETCH_LOOKUP_TABLES =
  "Successfully loaded depot map tiles.";
export const ERROR_FETCH_LOOKUP_TABLES = "Unable to load depot map tiles.";
export const ERROR_FETCH_SIMULATION_PERCENTAGES =
  "There was an issue trying to fetch simulated percentages";
export const SUCCESS_LOCK_DEPOT = "Depot locked successfully";
export const SUCCESS_UNLOCK_DEPOT = "Depot unlocked successfully";
export const SUCCESS_LOCK_PLAN = "Plan locked successfully";
export const SUCCESS_UNLOCK_PLAN = "Plan unlocked successfully";
export const SUCCESS_UNLOCK_MATRIX_DAY = ({ dayOfWeek }) =>
  `${FULL_DAYS[dayOfWeek]} matrix, routs and drivers has been successfully unlocked.`;
export const SUCCESS_UNLOCK_DEPOT_DRIVERS =
  "Depot drivers unlocked successfully";
export const SUCCESS_UNLOCK_MATRIX_WEEK =
  "Depot matrix week unlocked successfully";
export const SUCCESS_FETCH_PROFILES =
  "Available depot profiles loaded successfully.";
export const ERROR_FETCH_PROFILES =
  "Unable to load the list of available depot profiles.";
export const SUCCESS_FETCH_PROFILE = "Matrix profile loaded successfully.";
export const ERROR_FETCH_PROFILE = "Unable to load specified profile.";
export const SUCCESS_FETCH_VOLUME_OVERLAY =
  "Volume overlay loaded successfully.";
export const ERROR_FETCH_VOLUME_OVERLAY =
  "Unable to load specified volume overlay.";
export const SUCCESS_COPY_PLAN = (days) => {
  const dayNames = [...days].sort(sortWeekdays).map((day) => FULL_DAYS[day]);
  return `Plan successfully copied to ${dayNames.join(", ")}`;
};
export const NEW_PLAN_UNALLOCATED_DRIVERS_ROUTES = ({
  dayOfWeek,
  unallocatedDriversRoutes,
}) =>
  `${
    FULL_DAYS[dayOfWeek]
  } plan drivers allocated to routes ${unallocatedDriversRoutes.join(
    ", "
  )} have been unallocated.`;
export const ERROR_CREATE_PLAN = "There was an issue creating the plan";
export const SUCCESS_CREATE_PLAN = "Plan created successfully";
export const ERROR_EDIT_PLAN = "There was an issue editing the plan";
export const SUCCESS_EDIT_PLAN = "Plan edited successfully";
export const ERROR_DELETE_PLAN = "There was an issue deleting the plan";
export const SUCCESS_DELETE_PLAN = "Plan deleted successfully";
export const SUCCESS_PLAN_SAVED = "Plan saved successfully";
export const ERROR_PLAN_NOT_VALIDATED =
  "Plan is not valid. Please check for any errors";
export const ERROR_SAVING_PLAN = "There was an issue with saving the plan";
export const ERROR_INVALID_CHARACTERS =
  "Invalid characters used in template name";
export const ERROR_NAME_REQUIRED = "Template name is required";
export const SUCCESS_FETCH_ROBOT_SUPPLIERS =
  "Robot suppliers loaded successfully";
export const ERROR_FETCH_ROBOT_SUPPLIERS = "Unable to load robot suppliers";
export const SUCCESS_FETCH_VOLUME_OVERLAYS =
  "Volume overlays loaded successfully";
export const ERROR_FETCH_VOLUME_OVERLAYS = "Unable to load volume overlays";

// DRIVER MANAGEMENT
export const SUCCESS_FETCH_DEPOT_VEHICLES = "Vehicles loaded successfully";
export const ERROR_FETCH_DEPOT_VEHICLES = "Unable to load vehicles";
export const SUCCESS_FETCH_DEPOT_SECTIONS =
  "Depot sections loaded successfully";
export const ERROR_FETCH_DEPOT_SECTIONS = "Unable to load depot sections";
export const SUCCESS_FETCH_DEPOT_MATRIX = "Depot matrix loaded successfully";
export const ERROR_FETCH_DEPOT_MATRIX = "Unable to load depot matrix";
export const SUCCESS_FETCH_COUNTRY_CODES = "Country codes loaded successfully";
export const ERROR_FETCH_COUNTRY_CODES = "Unable to load country codes";
export const SUCCESS_FETCH_DRIVER_PREFIX =
  "Driver code prefixes loaded successfully";
export const ERROR_FETCH_DRIVER_PREFIX = "Unable to load driver code prefixes";
export const SUCCESS_FETCH_DRIVER_IMAGE =
  "Driver profile image loaded successfully";
export const ERROR_FETCH_DRIVER_IMAGE = "Unable to load Driver profile image";
export const SUCCESS_VALIDATE_DRIVER_IMAGE =
  "Driver profile image successfully validated";
export const ERROR_VALIDATE_DRIVER_IMAGE =
  "Driver profile image validation failed";
export const FETCH_DRIVER_CREATION_USERS_SUCCESS =
  "Driver creation users loaded successfully.";
export const FETCH_DRIVER_CREATION_USERS_ERROR =
  "Failed to load driver creation users.";

// ROUTE MANAGEMENT
export const SUCCESS_FETCH_DEPOT_ROUTES = "Depot routes loaded successfully";
export const ERROR_FETCH_DEPOT_ROUTES = "Unable to load depot routes";

// SHIFT MANAGERS MANAGEMENT
export const SUCCESS_FETCH_DEPOT_SHIFT_MANAGERS =
  "Depot shift managers loaded successfully";
export const ERROR_FETCH_DEPOT_SHIFT_MANAGERS =
  "Unable to load depot shift managers";
